var router = require('pjax').Router;
var index = require('./index.js');
var form = require('./form.js');

router.get('webhook/([a-zA-Z]+)', form);
router.get('webhook', index);
